@use 'variables' as *;
@use 'mixins' as *;
@import '~flatpickr/dist/flatpickr.css';
@import 'vendor/flatpickr';

:host {
  display: flex;
}

:host([hidden]) {
  display: none;
}

cat-input {
  flex: 1 1 auto;
  margin: 0;
}
